import amazon from "../download.png";
import character from "../character.png"
import library from "../library.png"
import payment from "../payment.png"
import todo from "../todo.png"
import modern from "../modern.png"
import file_upload from "../file_uploader.png"
import random from "../random.png"
import crypto from "../crypto.png"
const workData = [
    {
        id: 1,
        'title': 'Amazon Clone With Firebase',
        'description': 'This is Amazon Clone using react.js and firebase authentication. I use react context api for state management and materiail ui icons and designs for featuring .It has login , logout and add to cart option , where user can add their favourite products on cart ',
        'image': amazon,
        'link': 'https://github.com/CoderBoy061/Amazon-Clone-',
        "tech-stack": {
            1: "REACT.JS",
            2: "MATERIAL UI",
            3: "FIREBASE",
            4: "CONTEXT API",
        },

    },
    {
        id: 2,
        'title': 'Responsive Breaking Bad Character Search',
        'description': 'This is a responsive react.js breaking bad character search website. This is responsive for mobile or desktop. Where you can search any breaking bad character name to see their name and role in the web series. ',
        'image':character,
        'link': 'https://github.com/CoderBoy061/breaking_bad',
        "tech-stack": {
            1: "REACT.JS",
            2: "MATERIAL UI",
            3: "AXIOS",
            4: "API",
            5: "NODE.JS",
            6: "EXPRESS.JS",
            7: "HEROKU",
            8: "MongoDB",
            10: "JSONWEBTOKEN",
        }
    },
    {
        id: 3,
        'title': 'Mern stack library world',
        description:
            "This is a full stack mern library-world, where I used node.js,mongodb,jsonwebtoken for authentication, given choose profile picture option to the user,in the front-end I used React.js and material. In this project user can search any books, which I am rendering from google books api,then user can read the book(if it is available for free in the google book api),user can add their favourite book in favourite section and also remove the favourite book list,also implemented the logout functionality.",
        image: library,
        link: 'https://github.com/CoderBoy061/online-library',
        "tech-stack": {
            1: "REACT.JS",
            2: "MATERIAL UI",
            3: "NODE.JS",
            4: "MONGODB",
            5: "FIREBASE",
            6: "JSONWEBTOKEN",
            7: "GOOGLE-BOOK-API",
        },
    },
    {
        id: 4,
        'title': 'Simple shooping cart with razorpay',
        'description': 'This is a simple shooping cart with razorpay payment gateway. where user can add their favourite products on cart and pay with razorpay payment gateway. I used firebase firestore for saving the user favourite products. ',
        'image': payment,
        'link': 'https://deb-cart-shopping.netlify.app',
        "tech-stack": {
            1: "REACT.JS",
            2: "MATERIAL UI",
            3: "FIREBASE",
            4: "RAZORPAY",
            5: "FIRESTORE",
        },
    },
    {
        id: 5,
        'title': 'Simple redux todo',
        'description': 'This is a simple redux todo app. where user can add their favourite todo and delete it. I used redux for state management. ',
        'image':todo,
        'link': 'https://simple-redux-todo.netlify.app',
        "tech-stack": {
            1: "REACT.JS",
            2: "MATERIAL UI",
            3: "REDUX",
        }
    },
    {
        id: 6,
        'title': 'stylish modern sample page',
        'description': 'This is a stylish modern sample page. where I used react.js and material ui icons and designs for featuring . ',
        'image': modern,
        'link': 'https://new-modern-website.netlify.app',
        "tech-stack": {
            1: "REACT.JS",
            2: "MATERIAL UI",
            3: "CSS"
        }
    },
    {
        id: 7,
        'title': 'Full-stack File uploader 2',
        'description': 'This is a full-stack file uploader 2. where user can upload their favourite files and also delete it. I used mern stack to store user data and also jwt token authentication for user login and logout. ',
        'image': file_upload,
        'link': 'https://github.com/CoderBoy061/mern-stack-file-upload',
        "tech-stack": {
            1: "REACT.JS",
            2: "MATERIAL UI",
            3: "NODE.JS",
            4: "MONGODB",
            6: "JSONWEBTOKEN",
            7: "HEROKU"
        }

    },
    {
        id: 8,
        'title': 'Country details using react.js and material ui',
        'description': 'This is a country details using react.js and material ui. where user can search any country name to see their details. I used react.js and material ui icons and designs for featuring . ',
        'image':amazon,
        'link': 'https://addverb-technology.netlify.app',
        "tech-stack": {
            1: "REACT.JS",
            2: "MATERIAL UI",
        }
    },
    {
        id: 9,
        'title': 'Simple react.js Crypto app dashboard',
        'description': 'This is a simple react.js crypto app dashboard. where user can search any crypto name to see their details. I used react.js and material ui icons and designs for featuring . ',
        'image': crypto,
        'link': 'https://nurturelabstest.netlify.app',
        "tech-stack": {
            1: "REACT.JS",
            2: "MATERIAL UI",
        }
    },
    {
        id: 10,
        'title': 'Simple Random user with redux',
        'description': 'This is a simple random user with redux. where user can search any random user name to see their details. I used react.js and redux for state management. ',
        'image': random,
        'link': 'https://random-user-with-redux.netlify.app/',
        "tech-stack": {
            1: "REACT.JS",
            2: "MATERIAL UI",
            3: "REDUX",
        }
    }
]

export default workData;